import api from './api'

export default {
  /**
   * Получение текущего пользователя
   * @returns {Promise<any>}
   */
  getCurrentUser() {
    return api.get(`/auth/current_user`)
      .then((response) => response && response.data ? response.data : null)
      .catch(() => null) // Возвращаем null при ошибке
  },

  /**
   * Авторизация
   * @param username
   * @param password
   * @returns {Promise<AxiosResponse<T> | never>}
   */
  login(username, password) {
    return api
      .post(`/auth/login`, {
        username,
        password
      })
      .then(({ data }) => data)
  },

  /**
   * Логоут
   * @returns {Promise<any>}
   */
  logout() {
    return api.post(`/auth/logout/`).then(({ data }) => data)
  },

  /**
   * Востсановление пароля
   * @param who
   * @returns {Q.Promise<any>}
   */
  passwordRecovery(who) {
    return api.post(`/auth/reset_password/`, { who }).then(({ data }) => data)
  },

  /**
   * Список пользователей системы
   * @returns {*}
   */
  getUsers() {
    // Увеличиваем таймаут для получения списка пользователей, так как их может быть много
    return api.get(`/auth/get_users`, { timeout: 120000 }).then(({ data }) => data)
  },

  /**
   * Назначить право доступа пользователям
   * @param userIds {Array<number>}
   * @param permission {string}
   * @returns {Promise<any>}
   */
  assignPermission(userIds, permission) {
    return api.post(`/auth/assign_permissions`, {
      user_ids: userIds,
      permission: permission
    }).then(({ data }) => data)
  },

  /**
   * Получение настроек Active Directory из переменных окружения
   * @returns {Promise<any>}
   */
  getActiveDirectorySettings() {
    return api.get(`/auth/ad_settings`, null, { muteErrorHandler: true })
      .then((response) => response ? response.data : null)
      .catch(() => null) // Возвращаем null при ошибке, чтобы не ломать загрузку формы
  },

  /**
   * Тестирование подключения к Active Directory
   * @param data {Object} {server_address, username, password}
   * @returns {Promise<any>}
   */
  testActiveDirectoryConnection(data) {
    return api.post(`/auth/ad_test`, data).then(({ data }) => data)
  },

  /**
   * Синхронизация с Active Directory
   * @param data {Object} {server_address, username, password, group_name}
   * @returns {Promise<any>}
   */
  syncActiveDirectory(data) {
    // Увеличиваем таймаут для синхронизации AD, так как обработка большого количества пользователей может занять время
    // timeout передается в config (третий параметр), а не в options
    return api.post(`/auth/ad_sync`, data, { timeout: 300000 }).then(({ data }) => data)
  }
}
